
import 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.min.css'
export function onImagePreviewClick (e, index, imgList, key = 'image') {
  // 预览单张图片； index 直接传 0 ；
  var imageIndex = index
  var imageList
  if (Object.prototype.toString.call(imgList) === '[object Array]') {
    imageList = imgList
  } else if (Object.prototype.toString.call(imgList) === '[object Object]') {
    imageList = []
    imageList.push(imgList)
  }
  var dynamicEl = []
  _.each(imageList, function (value, index) {
    dynamicEl.push({
      'src': process.env.VUE_APP_IMGCDN + value[key],
      'thumb': process.env.VUE_APP_IMGCDN + value[key] + '!w100jpg',
      'poster': '',
      'downloadUrl': process.env.VUE_APP_IMGCDN + value[key]
    })
  })
  var option = {
    dynamic: true,
    dynamicEl: dynamicEl,
    index: imageIndex
  }

  var lg = $(e.target).closest('.lightgallery')[0]

  lightGallery(lg, option)
  lg.addEventListener('onCloseAfter', function (event) {
    // 关闭之后 初始化插件
    var lguid = lg.getAttribute('lg-uid')
    delete window.lgData[lguid]
    lg.removeAttribute('lg-uid')
  })
}
